import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppConfigService } from '@app/shared/services/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class ApiConnectionService {
  constructor(private http: HttpClient) {}

  checkApiConnection(): Observable<boolean> {
    return this.http.get(AppConfigService.settings.baseUrl + 'api/install/check-file').pipe(
      map(() => true),
      catchError(() => of(false)) // but it should be false.
    );
  }
}
